import { faPartyHorn } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { PropsWithChildren } from 'react';
import { useSession } from '@/lib/authClient';
import { LoginPage } from './LoginPage';

/** Gates the app behind a better-auth session: a brief loading splash while the
 *  session resolves, the login page when signed out, otherwise the app. */
export const AuthGate = ({ children }: PropsWithChildren) => {
  const { data, isPending } = useSession();

  if (isPending) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-gradient-to-br from-secondary-subtle via-primary-subtle to-secondary-subtle">
        <FontAwesomeIcon
          icon={faPartyHorn}
          className="animate-pulse text-4xl text-secondary-main"
        />
      </div>
    );
  }

  if (!data) return <LoginPage />;

  return <>{children}</>;
};
